import { ReactNode, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import CollapsableItem, { NotchColors } from '../collapsable-item/collapsable-item';
import CollapsablePanel from '../collapsable-panel/collapsable-panel';
import { CollapsableSize, Comment, CommentStatus } from '../types/ui-kit.types';
export interface CollapsableProps {
    id: string;
    title?: string;
    children?: ReactNode;
    comments?: Comment[];
    loadingAlerts?: boolean;
    loadingComments?: boolean;
    status?: CommentStatus;
    size?: CollapsableSize;
    color: NotchColors;
    highlightOnSelect?: boolean;
    containerClasses?: string;
    handleComment?(id: string, comment: string): Promise<unknown>;
    handleEdit?(id: string, commentId: string, comment: string): Promise<unknown>;
    handleDelete?(id: string, commentId: string): Promise<unknown>;
    emptyMessage?: string;
    testId?: string;
    disableComment?: boolean;
    showComments?: boolean;
}

export function Collapsable(props: CollapsableProps) {
    const [alertOpen, setAlertOpen] = useState(false);

    // Card Classes
    const statusClasses = {
        open: `shadow-qm-sm open`,
        resolved: `shadow-none closed`,
    };

    const classes = twMerge(
        'group/card bg-white transition border border-gray-50 rounded-md',
        statusClasses[props.status || 'open'],
        props.containerClasses,
    );

    return (
        <div id={props.id} className={classes} data-testid={props.testId ?? 'colapsable-container'}>
            <CollapsableItem
                label={props.children ? undefined : props.title ?? props.id}
                size={props.size ?? 'large'}
                status={props.status ?? 'open'}
                handleClick={() => setAlertOpen(!alertOpen)}
                color={props.color}
                highlightOnSelect={props.highlightOnSelect}
                isCollapsed={alertOpen}
            >
                {props.children}
            </CollapsableItem>
            {alertOpen && (
                <CollapsablePanel
                    comments={props.comments ?? []}
                    size={props.size ?? 'large'}
                    isLoadingMessages={props.loadingAlerts ?? false}
                    isLoadingActions={props.loadingComments ?? false}
                    emptyMessage={props.emptyMessage ?? 'Aún no hay comentarios.'}
                    collapsableId={props.id}
                    onEdit={props.handleEdit}
                    onCreate={props.handleComment}
                    onDelete={(commentId: string) =>
                        props.handleDelete
                            ? props.handleDelete(props.id, commentId)
                            : new Promise((resolve) => resolve(null))
                    }
                    disableComment={props.disableComment}
                />
            )}
        </div>
    );
}

Collapsable.defaultProps = {
    status: 'open',
    size: 'large',
};

export default Collapsable;
